import { api } from "../../services/api";

export const getBillingOverview = async () => {
  const { data } = await api.get("/api/billing/overview");

  return data?.data ?? null;
};

export const getBillingHistory = async ({ span, from, to, limit }) => {
  const params = { span };
  if (span === "custom") {
    params.from = from;
    params.to = to;
  }
  if (limit) params.limit = limit;

  const { data } = await api.get("/api/billing/history", { params });

  return data?.data ?? { records: [], summary: { purchasedCents: 0, usedCents: 0, count: 0 } };
};
